<template>
    <main class="mt-5">
        <div class="card mt-3">
            <div class="card-header border-0">
                <h5 class="card-title font-bold py-3">گزارش موجودی تنوع ها</h5>
                <div style="flex: 1"></div>
                <ExcelDownload :url="downloadUrl" class="ml-2"/>
                <button @click="print" class="btn btn-primary">
                    <span style="transform: translateY(3px)" class="feather-printer"></span>
                </button>
            </div>
            <div class="row px-4 not-in-print">
                <div class="row col-12">
                    <ProductSearch class="row col-md-12" ref="productSearch" :selectable="true" :disabled="disabled"
                        @selectProduct="selectProduct" :productOnly="true" :show-label="false" />
                </div>
                <b-button class="col-md-2" variant="primary" @click="doFilter" :disabled="disabled">فیلترسازی</b-button>
            </div>
            <div id="print" class="p-4">
                <b-table v-if="reports" bordered :items="reports" striped :fields="fields" responsive>
                    <template v-slot:cell(variety_name)="data">
                        <a target="_blank" :href="'/admin/products/edit/' + data.item.product_id">{{
                            data.item.variety_name }}</a>
                    </template>
                </b-table>
                <div v-if="!reports" class="alert alert-primary">در حال بارگزاری</div>
            </div>
        </div>
    </main>
</template>
<script>
import { BTable, BFormGroup, BFormInput, BButton, BTd, BFormCheckbox } from "bootstrap-vue";
import configProvider from "@@/core/configProvider";
import reportMixin from "@@/core/mixins/reportMixin";
import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";
import ExcelDownload from "@@/core/components/excelDownload/ExcelDownload.vue";
import CustomerSearch from "@@/core/components/shared/CustomerSearch/CustomerSearch";
export default {
    name: "VarietyBalance",
    components: {
        BTable,
        BFormGroup,
        BFormInput,
        ExcelDownload,
        ProductSearch,
        BButton,
        BTd,
        DatePickerRange,
        CustomerSearch,
        BFormCheckbox,
    },
    configProvider,
    data() {
        return {
            disabled: false,
            fields: [
                {
                    key: "product_id",
                    label: "شناسه محصول",
                },
                {
                    key: "variety_name",
                    label: "تنوع",
                },
                {
                    key: "central_store_balance",
                    label: "موجودی",
                },
            ],
            reports: null,
            sortDesc: null,
            totals: null,
            disabledRest: true,
        };
    },
    mixins: [reportMixin],
    mounted() {
        this.loadData();
    },
    computed: {
        downloadUrl() {
            const id = (this.Product_id && this.Product_id.id) ? this.Product_id.id : '';
            return `/admin/reports/variety-store-balance?product_id=${id}`;
        }
    },

    methods: {
        print() {
            window.print();
        },
        resetFilter() {
            this.disabledRest = true;
            this.loadData();
        },
        doFilter() {
            this.loadData();
        },
        selectProduct(data) {
            this.Product_id = data;
        },
        async loadData() {
            try {
                this.disabled = true;
                const response = await this.$axios.get("admin/reports/variety-store-balance", {
                    params: {
                        product_id: this.Product_id ? this.Product_id.id : "",
                    },
                });
                this.reports = response.data.data.reports;
                console.log(this.reports);
                this.totals = response.data.data.totals;
            } catch (e) {
                this.$root.notify(e);
            } finally {
                this.disabled = false;
            }
        },
    },
};
</script>
<style>
.print-only {
    display: none;
}

@media print {
    .not-in-print {
        display: none !important;
    }

    .app-content .side-app {
        padding: 0 !important;
    }

    .print-only {
        display: flex;
        justify-content: center;
    }

    body * {
        visibility: hidden;
    }

    #print,
    #print * {
        visibility: visible;
        font-size: 1.25rem;
    }

    #print {
        padding: 0 !important;
    }

    #print {
        width: 100%;
    }

    #print .not-in-print {
        display: none;
    }

    .mr-2-print {
        margin-right: 20px;
    }
}
</style>